import { render } from "./schedule.vue?vue&type=template&id=780010f4&scoped=true&ts=true"
import script from "./schedule.vue?vue&type=script&lang=ts"
export * from "./schedule.vue?vue&type=script&lang=ts"

import "./schedule.vue?vue&type=style&index=0&id=780010f4&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-780010f4"]])

export default __exports__